<template>
  <div class="Div">
    <!-- <header1></header1> -->
    <!-- 第一屏 -->
    <div
      class="InitialScreen"
      :style="'height:'+height+''"
    >
    <!-- background: url('+ScreenImg+') no-repeat center;background-size: cover; -->
    <img class="OneBackImg" :src="ScreenImg" alt="">
      <div class="sb">
        <img
          class="sbImg"
          src="../../../static/image/shubiao.png"
          alt=""
          srcset=""
        >
        <span class="sp1"></span>
        <span class="span"></span>
      </div>
    </div>
    <!-- 招生信息 -->
    <section
      class="section2"
    >
      <!-- :style="'background: url('+newsList.background_img+') no-repeat center;background-size: cover;'" -->
      <div class="stitle">
        <p class="p">{{newsList.classInfo.type_name_cn}}</p>
        <p class="p">{{newsList.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi2.png"
          alt=""
        >
      </div>
      <div class="content" v-if="newsList.list.length>0">
        <img
          class="img"
          src="../../../static/image/8-4.png"
          alt=""
        >
        <ul class="ul">
          <li
            class="li"
            v-for="(item,i) of newsList.list"
            :key="i"
            @click="detailClick(item,37)"
          >
            <span
              class="title ellipsis"
              :title="item.article_title_cn"
            >{{item.article_title_cn}}</span>
            <span class="time">{{item.send_time}}</span>
          </li>
          <li class="btnli">
            <el-button
              class="more"
              @click="moreRecruitment(newsList.classInfo.article_type_id,37)"
            >{{newsList.seeMore}}</el-button>
          </li>
        </ul>
      </div>
    </section>
    <!-- 招聘信息 -->
    <section class="section1">
      <img class="OneBackImg" :src="newsList.background_img" alt="">
      <div class="stitle">
        <p class="p">{{recruList.classInfo.type_name_cn}}</p>
        <p class="p">{{recruList.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="recruList.list.length>0">
        <div class="wrap wrap1">
          <div class="bulletin bulletin1">
            <div class="brief">
              <p
                class="ellipsis pTit"
                :title="recruList.list[0].article_describe_cn"
              >{{recruList.list[0].article_describe_cn}}</p>
            </div>
            <div
              class="detail"
              @click="detailClick(recruList.list[0],36)"
            >
              <p
                class="p1 ellipsis"
                :title="recruList.list[0].article_title_cn"
              >
                {{recruList.list[0].article_title_cn}}
              </p>
              <p class="time">
                {{recruList.list[0].send_time}}
              </p>
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="bulletin bulletin2">

            <div
              class="detail"
              @click="detailClick(recruList.list[1],36)"
            >
              <p
                class="p1 ellipsis"
                :title="recruList.list[0].article_title_cn"
              >
                {{recruList.list[0].article_title_cn}}
              </p>
              <p class="time">
                {{recruList.list[0].send_time}}
              </p>
            </div>
            <div class="brief">
              <p
                class="ellipsis pTit"
                :title="recruList.list[1].article_describe_cn"
              >{{recruList.list[1].article_describe_cn}}</p>
            </div>
          </div>
        </div>
      </div>
      <el-button
        class="more"
        @click="moreRecruitment(recruList.classInfo.article_type_id,36)"
      >{{recruList.seeMore}}</el-button>
    </section>

  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
// import header1 from "../../layout/AppHeader";
import {
  recruitmentInformation,
  enrollmentInformation
} from "../../api/Recruitment";
import {getBanner} from "../../api/home"
export default {
  name: "Recruitment",
  data() {
    return {
      ScreenImg: "",
      height: "", //高度
      newsList: { list: [{}, {}], classInfo: {} },
      warmNum: 0,
      warmHeight: 559,
      recruList: { list: [{}, {}], classInfo: {} }
    };
  },

  computed: {
    ...mapState("user", ["headerHeight"])
  },
  // components: {
  //   header1
  // },
  methods: {
    // 监听浏览器高度宽度变化
    getHeight() {
      //   console.log(this.headerHeight, "dfsf");
      this.height = window.innerHeight - this.headerHeight + "px";
    },
    // 查看更多
    moreRecruitment(id,x) {
      var laber = [0, 7, x,17];
      var laPath = ["/", "/Recruitment", "/Recruitment"];
      this.$router.push({
        path: "/RecruitmentList",
        query: {
          uid: id,
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath)
        }
      });
    },
    // 招聘详情
    detailClick(item,x) {
      var laber = [0, 7,x, 18];
      var laPath = ["/", "/Recruitment", "/Recruitment"];
      var routeData=this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: item.article_id
        }
      });
      window.open(routeData.href, "_blank");
    }
  },
  created() {
    // 招聘信息
    recruitmentInformation({
      limit: 2
    }).then(res => {
      // console.log(res.data)
      this.recruList = res.data;
    });
    // 招生信息
    enrollmentInformation({
      limit: 5
    }).then(res => {
      // console.log(res.data);
      this.newsList = res.data;
    });
    // 第一屏banner
    getBanner({
      address:11
    }).then(res=>{
      this.ScreenImg=res.data.banner_img
    })
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();

    // this.warmHeight=this.$refs.warmheight.offsetHeight+'px';
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.InitialScreen {
  position: relative;
  width: 100%;
  //   height: 79.5vh;
  background-size: cover;
  padding-top: 0.1px;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
    top: 0;
    left: 0;
  }
  .overview {
    position: relative;
    margin-left: 16.1%;
    margin-top: 5%;
    z-index: 1;
    text-align: left;
    .title {
      position: relative;
      font-size: px2Rem(80px);
      // font-family: "STXinwei";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: px2Rem(100px);
        height: px2Rem(4px);
        bottom: px2Rem(-30px);
        left: px2Rem(10px);
        border-radius: 2px;
        background-color: #fff;
      }
    }
    .overImg {
      width: px2Rem(38px);
      height: px2Rem(38px);
      margin-left: px2Rem(15px);
    }
    .caption {
      width: px2Rem(707px);
      margin-top: px2Rem(70px);
      font-size: px2Rem(28px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: px2Rem(35px);
    }
    .btn {
      padding: px2Rem(19px) px2Rem(68px);
      margin-top: px2Rem(60px);
      border: 2px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
}

.section1 {
  // width: px2Rem(1300px);
  position: relative;
  padding: px2Rem(60px) 0;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 0;
    top: 0;
    left: 0;
  }
  .OneBackImg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .stitle{
    position: relative;
    z-index: 10;
    .p{
      color: #fff;
    }
  }
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    //color: #fff;
    .wrap,
    .bulletin {
      width: px2Rem(1300px);
      height: px2Rem(140px);
      clear: both;
      font-size: 0;
      position: relative;
      z-index: 10;
    }
    .wrap1 {
      margin-bottom: px2Rem(40px);
    }
    .bulletin {
      width: px2Rem(1200px);
      border: 2px solid rgba(226, 187, 129, 1);
      border-radius: 8px;
      background-color: #fff;
    }
    .brief {
      position: relative;
      display: inline-block;
      width: px2Rem(390px);
      height: 100%;
      background: url("../../../static/image/8-2.png") no-repeat center;
      background-size: cover;
      font-size: px2Rem(40px);
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      vertical-align: top;
      p {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
      .pTit{
        padding: 0 px2Rem(20px);
      }
    }
    .detail {
      display: inline-block;
      width: px2Rem(805px);
      height: 100%;
      cursor: pointer;
      &:hover {
        .p1 {
          position: relative;
          left: px2Rem(-20px);
          color: #1c3278;
          // transition: .5s;
        }
      }
      .p1 {
        position: relative;
        margin: px2Rem(40px) px2Rem(0px) px2Rem(15px) px2Rem(20px);
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        //color: #fff;
        transition: 0.5s;
        left: 0;
      }
      .time {
        margin-left: px2Rem(20px);
        font-size: px2Rem(20px);
        font-weight: 400;
        color: #999;
      }
    }
    .bulletin2 {
      float: right;

      .brief {
        float: right;
        background: url("../../../static/image/8-3.png") no-repeat center;
        background-size: cover;
      }
      .detail {
        text-align: right;
        .p1 {
          margin-right: px2Rem(20px);
        }
        .time {
          margin-right: px2Rem(20px);
        }
      }
    }
  }
  .more{
    position: relative;
    z-index: 10;
    color: #fff;
    border-color: #fff;
  }
}
.section2 {
  position: relative;
  padding-top: px2Rem(60px);
  padding-bottom: px2Rem(50px);
  //&::before {
  //  display: block;
  //  position: absolute;
  //  content: "";
  //  width: 100%;
  //  height: 100%;
  //  background-color: rgba(0, 0, 0, 0.6);
  //  z-index: 0;
  //  top: 0;
  //  left: 0;
  //}
  .OneBackImg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .content {
    position: relative;
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    img {
      display: block;
      width: 100%;
    }
    .ul {
      background: #fff;
      border-radius: 0 0 16px 16px;
      .li {
        padding: px2Rem(30px) px2Rem(18px);
        border-bottom: 1px dashed #ddd;
        cursor: pointer;
        clear: both;
        transition: .5s;
        &:hover {
          box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.16);
      // color: rgba(28, 50, 120, 1);
          .title {
            color: #1c3278;
          }
        }
        .title {
          display: inline-block;
          width: 85%;
          font-size: px2Rem(28px);
          // font-family: STXinwei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .time {
          float: right;
          margin-top: px2Rem(6px);
          font-size: px2Rem(20px);
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
      .btnli {
        margin-top: px2Rem(22px);
        padding-bottom: px2Rem(22px);
      }
    }
  }
  .stitle {
    position: relative;
    //p {
    //  color: rgba(255, 255, 255, 1);
    //  &:nth-of-type(2) {
    //    color: rgba(255, 255, 255, 1);
    //  }
    //}
  }
}
.more {
  display: block;
  margin: px2Rem(10px) auto 0px;
  padding: px2Rem(20px) px2Rem(68);
  border: 1px solid rgba(28, 50, 120, 1);
  border-radius: 4px;
  font-size: px2Rem(24px);
  // font-family: STXinwei;
  background: rgba(0, 0, 0, 0);
  font-weight: 400;
  color: rgba(28, 50, 120, 1);
  transition: 0.3s;
 &:hover {
    background: rgba(28, 50, 120, 0.5);
    color: #fff;
    border: 1px solid #fff;
  }
}
.title {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruitment/Index.vue